export const RA2_EDIT_CONFIG = {
  apiEndpoint: '/api/ra2-image-editor',
  creditCost: 4,
  creditCostUSD: '0.04',
  maxRetries: 10,
  retryDelay: 1000,
  defaultAspect: 'square',
  maxUploadBytes: 10 * 1024 * 1024,
  acceptedTypes: ['image/png', 'image/jpeg', 'image/webp'],
  aspects: {
    square: { width: 1024, height: 1024, key: 'square' },
    landscape: { width: 1152, height: 768, key: 'landscape' },
    portrait: { width: 768, height: 1152, key: 'portrait' },
    landscape43: { width: 1152, height: 864, key: 'landscape43' },
    portrait43: { width: 864, height: 1152, key: 'portrait43' },
    widescreen: { width: 1360, height: 768, key: 'widescreen' },
    tall: { width: 768, height: 1360, key: 'tall' },
  },
};

let editInProgress = false;
let currentRetry = 0;
let sourceObjectURL = null;
let initialized = false;

export function getAspectConfig(aspectId) {
  return RA2_EDIT_CONFIG.aspects[aspectId];
}

function element(id) {
  return document.getElementById(id);
}

function showToast(message, type) {
  if (typeof window.showToast === 'function') {
    window.showToast(message, { type: type || 'info' });
    return;
  }
  alert(message);
}

function requireToolLogin() {
  if (typeof NetwrckTools !== 'undefined' && typeof NetwrckTools.requireLogin === 'function') {
    return NetwrckTools.requireLogin();
  }
  return !!(window.userData && window.userData.secret && window.userData.secret !== 'anonymous');
}

function resolveSecret() {
  const credentials =
    typeof window.getAuthCredentials === 'function' ? window.getAuthCredentials() : null;
  const secret =
    (credentials && credentials.secret) || (window.userData && window.userData.secret) || null;
  return secret && secret !== 'anonymous' ? secret : null;
}

function selectedAspect() {
  const checked = document.querySelector('input[name="aspect"]:checked');
  if (checked && checked.id) return checked.id.replace('aspect', '');
  return RA2_EDIT_CONFIG.defaultAspect;
}

function promptValue() {
  const input = element('createrea2editprompt');
  return input ? input.value.trim() : '';
}

function urlValue() {
  const input = element('ra2-edit-image-url');
  return input ? input.value.trim() : '';
}

function selectedFile() {
  const input = element('ra2-edit-file');
  return input && input.files && input.files[0] ? input.files[0] : null;
}

function isAcceptableFile(file) {
  if (!file) return false;
  if (RA2_EDIT_CONFIG.acceptedTypes.includes(file.type)) return true;
  return !file.type && /\.(png|jpe?g|webp)$/i.test(file.name || '');
}

function escapeAttribute(value) {
  return String(value == null ? '' : value)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
}

function delay(ms) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

function resolveImageUrl(result) {
  if (!result) return null;
  if (result.image_url) return result.image_url;
  if (result.images && result.images.length > 0) return result.images[0].url || result.images[0];
  return null;
}

function acceptFile(file) {
  if (!file) return;
  if (!isAcceptableFile(file)) {
    showToast('Please choose a PNG, JPEG or WEBP image.', 'error');
    const input = element('ra2-edit-file');
    if (input) input.value = '';
    return;
  }
  if (file.size > RA2_EDIT_CONFIG.maxUploadBytes) {
    showToast('Image must be 10MB or smaller.', 'error');
    const input = element('ra2-edit-file');
    if (input) input.value = '';
    return;
  }

  if (sourceObjectURL) URL.revokeObjectURL(sourceObjectURL);
  sourceObjectURL = URL.createObjectURL(file);

  const preview = element('ra2-edit-preview');
  if (preview) preview.src = sourceObjectURL;

  const name = element('ra2-edit-name');
  if (name) name.textContent = file.name || 'image';

  const placeholder = element('ra2-edit-placeholder');
  if (placeholder) placeholder.style.display = 'none';

  const wrap = element('ra2-edit-preview-wrap');
  if (wrap) wrap.style.display = 'block';

  const urlInput = element('ra2-edit-image-url');
  if (urlInput) urlInput.value = '';
}

function clearSource() {
  const input = element('ra2-edit-file');
  if (input) input.value = '';
  if (sourceObjectURL) {
    URL.revokeObjectURL(sourceObjectURL);
    sourceObjectURL = null;
  }
  const preview = element('ra2-edit-preview');
  if (preview) preview.removeAttribute('src');
  const wrap = element('ra2-edit-preview-wrap');
  if (wrap) wrap.style.display = 'none';
  const placeholder = element('ra2-edit-placeholder');
  if (placeholder) placeholder.style.display = 'flex';
  const name = element('ra2-edit-name');
  if (name) name.textContent = '';
}

function setupUpload() {
  const dropZone = element('ra2-edit-drop');
  const fileInput = element('ra2-edit-file');
  if (!dropZone || !fileInput) return;

  dropZone.addEventListener('click', function (event) {
    if (event.target === fileInput || event.target.closest('#ra2-edit-remove')) return;
    fileInput.click();
  });

  fileInput.addEventListener('change', function () {
    acceptFile(fileInput.files && fileInput.files[0]);
  });

  ['dragenter', 'dragover'].forEach(function (name) {
    dropZone.addEventListener(name, function (event) {
      event.preventDefault();
      dropZone.classList.add('is-dragover');
    });
  });

  ['dragleave', 'drop'].forEach(function (name) {
    dropZone.addEventListener(name, function (event) {
      event.preventDefault();
      dropZone.classList.remove('is-dragover');
    });
  });

  dropZone.addEventListener('drop', function (event) {
    const files = event.dataTransfer && event.dataTransfer.files;
    if (files && files[0]) acceptFile(files[0]);
  });

  const removeButton = element('ra2-edit-remove');
  if (removeButton) {
    removeButton.addEventListener('click', function (event) {
      event.stopPropagation();
      clearSource();
    });
  }

  document.addEventListener('paste', function (event) {
    const items = event.clipboardData && event.clipboardData.items;
    if (!items || !document.body.contains(dropZone)) return;
    for (let index = 0; index < items.length; index++) {
      if (items[index].type && items[index].type.indexOf('image') !== -1) {
        acceptFile(items[index].getAsFile());
        break;
      }
    }
  });

  const urlInput = element('ra2-edit-image-url');
  if (urlInput) {
    urlInput.addEventListener('input', function () {
      if (urlInput.value.trim() !== '') clearSource();
    });
  }
}

function setupAspectRatioHandlers() {
  jQuery('input[name="aspect"]').on('change', function () {
    savePreference('lastAspect', selectedAspect());
  });
}

function setupPromptDraft() {
  const input = element('createrea2editprompt');
  if (!input) return;
  let saveTimeout;
  input.addEventListener('input', function () {
    clearTimeout(saveTimeout);
    saveTimeout = setTimeout(function () {
      savePreference('draftPrompt', input.value);
    }, 1000);
  });
}

function setupKeyboardShortcuts() {
  jQuery(document).on('keydown', function (event) {
    if ((event.ctrlKey || event.metaKey) && event.keyCode === 13) {
      event.preventDefault();
      editRA2Image();
    }
    if (event.keyCode === 27 && jQuery('#createrea2editprompt').is(':focus')) {
      jQuery('#createrea2editprompt').val('').blur();
    }
  });
}

function setupDownloadHandler() {
  const list = element('createdRA2EditList');
  if (!list || list.dataset.downloadBound === 'true') return;
  list.dataset.downloadBound = 'true';
  list.addEventListener('click', function (event) {
    const button = event.target.closest('.download-btn');
    if (!button || !list.contains(button)) return;
    event.preventDefault();
    downloadEditImage(button.dataset.url, button.dataset.prompt || '');
  });
}

function loadSavedPreferences() {
  const savedAspect = getPreference('lastAspect');
  const savedRadio = savedAspect ? element(savedAspect + 'aspect') : null;
  if (savedRadio && getAspectConfig(savedAspect)) {
    savedRadio.checked = true;
    jQuery(savedRadio).trigger('change');
    if (typeof componentHandler !== 'undefined') componentHandler.upgradeDom();
  }

  const draftPrompt = getPreference('draftPrompt');
  const input = element('createrea2editprompt');
  if (draftPrompt && input) input.value = draftPrompt;
}

function savePreference(key, value) {
  try {
    localStorage.setItem('ra2_edit_' + key, value);
  } catch (error) {
    console.warn('Could not save preference:', error);
  }
}

function getPreference(key) {
  try {
    return localStorage.getItem('ra2_edit_' + key);
  } catch (error) {
    console.warn('Could not load preference:', error);
    return null;
  }
}

function clearDraftPrompt() {
  try {
    localStorage.removeItem('ra2_edit_draftPrompt');
  } catch (error) {
    console.warn('Could not clear draft prompt:', error);
  }
}

function incrementGenerationCounter() {
  const next = (window.subscribeImageGenCounter || 0) + 1;
  window.subscribeImageGenCounter = next;
  setCookie('subscribeImageGenCounter', next, 365);
}

function setCookie(name, value, days) {
  const expires = new Date();
  expires.setTime(expires.getTime() + days * 24 * 60 * 60 * 1000);
  document.cookie = name + '=' + value + ';expires=' + expires.toUTCString() + ';path=/';
}

function applyChargedCredits(result) {
  const charged = Number(result && result.credits_charged) || 0;
  if (!charged || !window.userData || window.userData.credits === undefined) return;
  window.userData.credits = Math.max(0, (Number(window.userData.credits) || 0) - charged);
  jQuery('.api-credits-balance-usd').text(parseFloat(window.userData.credits).toFixed(2));
  jQuery('.api-credits-balance').text(window.userData.credits);
}

function trackToolUsage() {
  if (typeof trackEvent === 'function') {
    trackEvent('tool', 'load', 'ra2-image-editor');
  }
}

function trackSuccessfulEdit(prompt, source) {
  if (typeof trackEvent === 'function') {
    trackEvent('tool', 'edit-success', 'ra2-image-editor', {
      aspect: selectedAspect(),
      source: source,
      promptLength: prompt.length,
    });
  }
}

function trackFailedEdit(error) {
  if (typeof trackEvent === 'function') {
    trackEvent('tool', 'edit-error', 'ra2-image-editor', {
      error: error && error.message ? error.message : 'unknown',
    });
  }
}

async function editWithRetry(payload, secret, sizeKey) {
  const headers = {
    'X-API-Key': secret,
    Authorization: 'Bearer ' + secret,
  };

  let requestHeaders = headers;
  let requestBody;
  if (payload.file) {
    const form = new FormData();
    form.append('image', payload.file, payload.file.name || 'source.png');
    form.append('prompt', payload.prompt);
    form.append('size', sizeKey);
    form.append('api_key', secret);
    requestBody = form;
  } else {
    requestHeaders = Object.assign({}, headers, { 'Content-Type': 'application/json' });
    requestBody = JSON.stringify({
      prompt: payload.prompt,
      image_url: payload.imageUrl,
      size: sizeKey,
      api_key: secret,
    });
  }

  for (;;) {
    let response;
    try {
      response = await fetch(RA2_EDIT_CONFIG.apiEndpoint, {
        method: 'POST',
        headers: requestHeaders,
        credentials: 'include',
        body: requestBody,
      });
    } catch (error) {
      throw new Error('Connection failed. Please check your network and try again.');
    }

    const result = await response.json().catch(function () {
      return {};
    });

    if (window.NetwrckPaywall && window.NetwrckPaywall.check(response, result, { feature: 'the image editor' })) {
      throw window.NetwrckPaywall.error();
    }

    if (!response.ok || result.success === false) {
      if (response.status >= 500 && currentRetry < RA2_EDIT_CONFIG.maxRetries) {
        currentRetry++;
        await delay(RA2_EDIT_CONFIG.retryDelay);
        continue;
      }
      throw new Error(
        window.NetwrckPaywall ? window.NetwrckPaywall.message(result, 'Image edit failed') : result.error || 'Image edit failed'
      );
    }

    return result;
  }
}

export async function editRA2Image() {
  if (editInProgress) return;
  if (typeof NetwrckTools === 'undefined') {
    setTimeout(editRA2Image, 100);
    return;
  }

  if (window.NetwrckPaywall) {
    if (!window.NetwrckPaywall.require({ feature: 'the image editor', credits: RA2_EDIT_CONFIG.creditCost })) return;
  } else {
    if (!requireToolLogin()) {
      if (typeof window.showSubscribeDialog === 'function') window.showSubscribeDialog();
      return;
    }
    if (!NetwrckTools.checkCredits(RA2_EDIT_CONFIG.creditCost, RA2_EDIT_CONFIG.creditCostUSD)) {
      return;
    }
    if (!NetwrckTools.checkSubscription()) {
      return;
    }
  }

  const prompt = promptValue();
  if (!prompt) {
    showToast('Please describe the edit you want.', 'warning');
    const input = element('createrea2editprompt');
    if (input) input.focus();
    return;
  }

  const file = selectedFile();
  if (file && !isAcceptableFile(file)) {
    showToast('Please choose a PNG, JPEG or WEBP image.', 'error');
    return;
  }
  if (file && file.size > RA2_EDIT_CONFIG.maxUploadBytes) {
    showToast('Image must be 10MB or smaller.', 'error');
    return;
  }

  const imageUrl = urlValue();
  if (!file && !imageUrl) {
    showToast('Please upload an image or paste an image URL to edit.', 'warning');
    const dropZone = element('ra2-edit-drop');
    if (dropZone) dropZone.classList.add('needs-source');
    return;
  }

  const secret = resolveSecret();
  if (!secret) {
    NetwrckTools.requireLogin();
    return;
  }

  const aspect = getAspectConfig(selectedAspect()) || RA2_EDIT_CONFIG.aspects.square;
  const beforeUrl = file ? sourceObjectURL || previewSrc() : imageUrl;

  editInProgress = true;
  currentRetry = 0;
  NetwrckTools.showLoading('create-ai-loading-progress');

  try {
    const result = await editWithRetry({ file, imageUrl, prompt }, secret, aspect.key);
    const resultUrl = resolveImageUrl(result);
    if (!resultUrl) throw new Error('No edited image was returned');
    displayEditResult(resultUrl, beforeUrl, prompt);
    applyChargedCredits(result);
    clearDraftPrompt();
    trackSuccessfulEdit(prompt, file ? 'upload' : 'url');
  } catch (error) {
    if (error && error.paywall) return;
    console.error('Edit failed:', error);
    showToast(
      error && error.message ? error.message : 'An error occurred. Please try again.',
      'error'
    );
    trackFailedEdit(error);
  } finally {
    editInProgress = false;
    NetwrckTools.hideLoading('create-ai-loading-progress');
  }
}

function previewSrc() {
  const preview = element('ra2-edit-preview');
  return preview ? preview.getAttribute('src') : null;
}

export function displayEditResult(imageUrl, beforeUrl, prompt) {
  const list = element('createdRA2EditList');
  if (!list || !imageUrl) return null;

  const item = document.createElement('div');
  item.className = 'ra2-edit-item';
  item.title = prompt || 'RA2 edited image';
  item.dataset.url = imageUrl;
  if (beforeUrl) item.dataset.beforeUrl = beforeUrl;

  const beforePane = beforeUrl
    ? '<figure class="ra2-edit-pane ra2-edit-before"><img loading="lazy" src="' +
      escapeAttribute(beforeUrl) +
      '" alt="Before edit"><figcaption>Before</figcaption></figure>'
    : '';

  item.innerHTML =
    '<div class="ra2-edit-compare">' +
    beforePane +
    '<figure class="ra2-edit-pane ra2-edit-after">' +
    '<img loading="lazy" src="' +
    escapeAttribute(imageUrl) +
    '" alt="' +
    escapeAttribute(prompt || 'After edit') +
    '" data-prompt="' +
    escapeAttribute(prompt || '') +
    '" data-timestamp="' +
    Date.now() +
    '" onerror="this.onerror=null; this.src=\'https://netwrckstatic.netwrck.com/static/img/netwrck-logo-colord256.webp\';">' +
    '<figcaption>After</figcaption></figure>' +
    '</div>' +
    '<div class="image-actions">' +
    '<a href="' +
    escapeAttribute(imageUrl) +
    '" target="_blank" class="action-btn" title="View full size"><i class="material-icons">open_in_new</i></a>' +
    '<a href="https://editor.ebank.nz/index.html?imageUrl=' +
    encodeURIComponent(imageUrl) +
    '" target="_blank" class="action-btn" title="Open in Editor"><i class="material-icons">brush</i></a>' +
    '<a class="action-btn download-btn" data-url="' +
    escapeAttribute(imageUrl) +
    '" data-prompt="' +
    escapeAttribute(prompt || '') +
    '" title="Download"><i class="material-icons">download</i></a>' +
    '</div>';

  list.prepend(item);

  if (typeof componentHandler !== 'undefined') componentHandler.upgradeDom();

  incrementGenerationCounter();

  return item;
}

async function downloadEditImage(imageUrl, prompt) {
  if (!imageUrl) return;
  try {
    const response = await fetch(imageUrl);
    const blob = await response.blob();
    const objectURL = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = objectURL;
    link.download =
      'ra2-edit-' +
      String(prompt || 'image')
        .slice(0, 30)
        .replace(/[^a-z0-9]/gi, '-') +
      '-' +
      Date.now() +
      '.png';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(objectURL);
  } catch (error) {
    console.error('Download failed:', error);
    window.open(imageUrl, '_blank');
  }
}

export function initializeRA2Editor() {
  if (typeof window === 'undefined') return;
  window.editRA2Image = editRA2Image;
  if (initialized) return;

  if (typeof jQuery === 'undefined' || typeof NetwrckTools === 'undefined') {
    setTimeout(initializeRA2Editor, 100);
    return;
  }

  jQuery(document).ready(function () {
    if (initialized) return;
    initialized = true;
    setupUpload();
    setupAspectRatioHandlers();
    setupPromptDraft();
    setupKeyboardShortcuts();
    setupDownloadHandler();
    loadSavedPreferences();
    trackToolUsage();
  });
}

initializeRA2Editor();
